import { memo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const otherFields = {
  lungs: 'Lungs',
  heart: 'Heart',
  thyroidGland: 'Thyroid Gland',
  breast: 'Breast',
};

const Others = ({ selectedOnExamination, setSelectedOnExamination }) => {
  const others = selectedOnExamination?.others || {
    lungs: '',
    heart: '',
    thyroidGland: '',
    breast: '',
  };

  const handleData = (field, value) => {
    const updatedOthers = { ...others, [field]: value };
    setSelectedOnExamination({
      ...selectedOnExamination,
      others: updatedOthers,
    });
  };

  return (
    <div className="surgical-history">
      {Object.entries(otherFields).map(([field, label]) => (
        <Row key={field} className="mb-2">
          <Col md={3} className="pt-1">
            {label}
          </Col>
          <Col>
            <Form.Control
              size="sm"
              as="textarea"
              rows={1}
              //placeholder={`Add ${label}`}
              defaultValue={others[field] || ''}
              onChange={(e) => handleData(field, e.target.value)}
            />
          </Col>
        </Row>
      ))}
      <Row className="mb-2 mt-3">
        <Col md={3} className="pt-1">
          P/A/E
        </Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`show-picture00`}
            label={`Show Urinary Bladder In Males Picture`}
            checked={others?.isUrinaryBladderInMale === true}
            onChange={(e) =>
              handleData('isUrinaryBladderInMale', e.target.checked)
            }
          />
        </Col>
      </Row>
      <Row className="mb-2">
        <Col md={3} className="pt-1">
          P/R/E
        </Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`show-picture11`}
            label={`Show Ovary Picture`}
            checked={others?.isOvary === true}
            onChange={(e) =>
              handleData('isOvary', e.target.checked)
            }
          />
        </Col>
      </Row>
      <Row className="mb-2">
        <Col md={3} className="pt-1"></Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`show-picture22`}
            label={`Show Human Urinary Bladder Picture`}
            checked={others?.isHumanUrinaryBladder === true}
            onChange={(e) =>
              handleData('isHumanUrinaryBladder', e.target.checked)
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(Others);
